import React from 'react';

export const SegmentationCollapsed: React.FC<{ children?: React.ReactNode }> = ({
  children = null,
}) => {
  return <div>{children}</div>;
};
